import { takeLatest } from 'redux-saga/effects';

import {
  UPDATE_CREDIT_CARD
} from '../actions';

import {
  updateCreditCard
} from './sagas';

// Watchers
export function* onUpdateCreditCard() {
  yield takeLatest(UPDATE_CREDIT_CARD, updateCreditCard);
}



// WEBPACK FOOTER //
// ./src/modules/stripe/actions/watchers.js